const state = {
  dbPageSize: false,
  dbTeamsCount: '',
};

const mutations = {
  setdbPageSize(localState, newdbPageSize) {
    localState.dbPageSize = newdbPageSize;
  },
  setdbTeamsCount(localState, newdbTeamsCount) {
    localState.dbTeamsCount = newdbTeamsCount;
  },
};

const actions = {
  selectdbPageSize({ commit }, dbPageSize) {
    commit('setdbPageSize', dbPageSize);
  },
  selectdbTeamsCount({ commit }, dbTeamsCount) {
    commit('setdbTeamsCount', dbTeamsCount);
  },
};

export default {
  mutations,
  actions,
  state,
};
